module.exports = __webpack_public_path__ + "img/tanker_green.2b4aa83f.svg";